export const CHECK_IS_USER_LOGGED_IN = 'CHECK_IS_USER_LOGGED_IN';
export const CHECK_IS_USER_LOGGED_IN_SUCCESS = 'CHECK_IS_USER_LOGGED_IN_SUCCESS';
export const CHECK_IS_USER_LOGGED_IN_FAILURE = 'CHECK_IS_USER_LOGGED_IN_FAILURE';
export const CHECK_IS_USER_LOGGED_IN_CANCELLED = 'CHECK_IS_USER_LOGGED_IN_CANCELLED';

export const checkIsUserLoggedIn = () => ({
    type: CHECK_IS_USER_LOGGED_IN,
});

export const checkIsUserLoggedInSuccess = (isUserLoggedIn) => ({
    type: CHECK_IS_USER_LOGGED_IN_SUCCESS,
    payload: { isUserLoggedIn }
});


export const checkIsUserLoggedInFailure = (message) => ({
    type: CHECK_IS_USER_LOGGED_IN_FAILURE,
    payload: { message }
});



